import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "../data/translations";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState("es");
    const t = translations[lang];
    const toggleLang = useCallback(() => {
        setLang((l) => (l === "es" ? "en" : "es"));
    }, []);

    return (
        <LanguageContext.Provider value={{ lang, setLang, t, toggleLang }}>
            {children}
        </LanguageContext.Provider>
    );
}

export const useLanguage = () => useContext(LanguageContext);
